import { useState } from "react";
import useChatDQP from "../../custom-hooks/useChatDQP";

export const ChatDQPButton = ({ className = '' }) => {
  const { setOpen } = useChatDQP();
  const [shimmerKey, setShimmerKey] = useState(0);
  return (
    <button
      type="button"
      onClick={() => setOpen(true)}
      onMouseEnter={() => setShimmerKey((prev) => prev + 1)}
      className={`group p-2 text-gray-400 hover:text-indigo-600 transition-colors rounded-md hover:bg-gray-100 relative ${className}`}
      aria-label="ChatDiligent"
      title="ChatDiligent"
    >
      <svg
        key={shimmerKey}
        className="h-6 w-6 ai-shimmer-icon"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
      >
        <defs>
          <linearGradient
            id="ai-rainbow-gradient"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#6036C4" stopOpacity="1" />
            <stop offset="8%" stopColor="#A68FF4" stopOpacity="1" />
            <stop offset="15%" stopColor="#F15B2B" stopOpacity="1" />
            <stop offset="23%" stopColor="#FCD5C4" stopOpacity="1" />
            <stop offset="31%" stopColor="#FFE600" stopOpacity="1" />
            <stop offset="38%" stopColor="#FEF8C0" stopOpacity="1" />
            <stop offset="46%" stopColor="#0ACC59" stopOpacity="1" />
            <stop offset="54%" stopColor="#C7E5CE" stopOpacity="1" />
            <stop offset="62%" stopColor="#04C4FF" stopOpacity="1" />
            <stop offset="69%" stopColor="#3A82F4" stopOpacity="1" />
            <stop offset="77%" stopColor="#C5E9F9" stopOpacity="1" />
            <stop offset="85%" stopColor="#130C4F" stopOpacity="1" />
            <stop offset="92%" stopColor="#44289E" stopOpacity="1" />
            <stop offset="100%" stopColor="#6036C4" stopOpacity="1" />
            <animate
              attributeName="x1"
              values="-100%;200%"
              dur="6s"
              repeatCount="1"
              fill="freeze"
            />
            <animate
              attributeName="y1"
              values="200%;-100%"
              dur="6s"
              repeatCount="1"
              fill="freeze"
            />
            <animate
              attributeName="x2"
              values="100%;400%"
              dur="6s"
              repeatCount="1"
              fill="freeze"
            />
            <animate
              attributeName="y2"
              values="0%;-300%"
              dur="6s"
              repeatCount="1"
              fill="freeze"
            />
          </linearGradient>
        </defs>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="url(#ai-rainbow-gradient)"
          d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
        />
      </svg>
    </button>
  );
};
